function FreeSpace() {
	return (
            <div className='freeSpace'>
            </div>
    )
}

export default FreeSpace
